import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import { SeoConfigProvider } from "@/components/GlobalSEOConfig";

const Layout = lazy(() => import("@/components/Layout"));
const Home = lazy(() => import("@/pages/Home"));
const Services = lazy(() => import("@/pages/Services"));
const ServiceLandingPage = lazy(() => import("@/pages/ServiceLandingPage"));
const DevOps = lazy(() => import("@/pages/DevOps"));
const Expertise = lazy(() => import("@/pages/Expertise"));
const Process = lazy(() => import("@/pages/Process"));
const SeoPage = lazy(() => import("@/pages/Seo"));
const Clients = lazy(() => import("@/pages/Clients"));
const Contact = lazy(() => import("@/pages/Contact"));
const FaqPage = lazy(() => import("@/pages/Faq"));

const AdminLayout = lazy(() => import("@/admin/components/AdminLayout"));
const AdminLogin = lazy(() => import("@/admin/pages/Login"));
const MediaLibrary = lazy(() => import("@/admin/pages/Media"));
const SeoSettings = lazy(() => import("@/admin/pages/SeoSettings"));
const SmtpSettings = lazy(() => import("@/admin/pages/SmtpSettings"));
const CookieSettings = lazy(() => import("@/admin/pages/CookieSettings"));
const PagesManager = lazy(() => import("@/admin/pages/PagesManager"));
const PageEditor = lazy(() => import("@/admin/pages/PageEditor"));
const ServicePagesManager = lazy(() => import("@/admin/pages/ServicePagesManager"));
const ServicePageEditor = lazy(() => import("@/admin/pages/ServicePageEditor"));
const ContactMessages = lazy(() => import("@/admin/pages/ContactMessages"));
const FaqManager = lazy(() => import("@/admin/pages/FaqManager"));

const DashboardDummy = () => <h1 className="text-2xl font-bold text-white">Bun venit în Panoul de Administrare</h1>;

const RouteFallback = () => (
    <div className="min-h-screen bg-[#020617] text-slate-400 flex items-center justify-center px-5">
        Se încarcă...
    </div>
);

function App() {
    return (
        <SeoConfigProvider>
            <BrowserRouter>
                <Suspense fallback={<RouteFallback />}>
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/servicii" element={<Services />} />
                            <Route path="/servicii/:slug" element={<ServiceLandingPage />} />
                            <Route path="/devops" element={<DevOps />} />
                            <Route path="/expertiza" element={<Expertise />} />
                            <Route path="/proces" element={<Process />} />
                            <Route path="/seo" element={<SeoPage />} />
                            <Route path="/clienti" element={<Clients />} />
                            <Route path="/faq" element={<FaqPage />} />
                            <Route path="/contact" element={<Contact />} />
                        </Route>

                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminLayout />}>
                            <Route path="dashboard" element={<DashboardDummy />} />
                            <Route path="pages" element={<PagesManager />} />
                            <Route path="pages/:slug" element={<PageEditor />} />
                            <Route path="services" element={<ServicePagesManager />} />
                            <Route path="services/:serviceId" element={<ServicePageEditor />} />
                            <Route path="contact-messages" element={<ContactMessages />} />
                            <Route path="faq" element={<FaqManager />} />
                            <Route path="media" element={<MediaLibrary />} />
                            <Route path="seo" element={<SeoSettings />} />
                            <Route path="smtp" element={<SmtpSettings />} />
                            <Route path="cookies" element={<CookieSettings />} />
                        </Route>
                    </Routes>
                </Suspense>
                <Toaster theme="dark" position="bottom-right" />
            </BrowserRouter>
        </SeoConfigProvider>
    );
}

export default App;
